export default __webpack_public_path__ + "static/media/img_man01.dc1a64c8.png";